<template>
  <div id="app">
    <Overlay />
    <Alert />

    <div :style="`${ isMdOrHigher && $route.name !== 'home' ? 'padding-left:265px' : ''}`">
      <b-container>
        <div class="col-sm-12 m-auto" id="topMenu">
          <b-navbar toggleable="lg" type="light" variant="white" class="p-0 py-3">
            <b-navbar-brand @click="redirectToProfile">
              <!-- <img src="./assets/logo.png" width="350px" /> -->
              <img src="https://renderer-v2.vercel.app/_next/image?url=https%3A%2F%2Fapi.typedream.com%2Fv0%2Fdocument%2Fpublic%2F8b8979cc-c0d4-422e-bb32-32729a8be571_CareerPilot_Final-01_png.png%3Fbucket%3Ddocument&amp;w=384&amp;q=75" style="height:42px;max-height:3rem" alt="website logo">
            </b-navbar-brand>
            <!-- <b-navbar-toggle v-b-toggle.mobile-sidebar target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto" v-if="user == null">
                <b-nav-item class="nav-link" to="#">About</b-nav-item>
                <b-nav-item-dropdown class="nav-link" text="Company" right>
                  <b-dropdown-item class="dropdown-item" :to="{name: 'login'}">Login</b-dropdown-item>
                  <b-dropdown-item class="dropdown-item" to="/register?t=company">Register</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown class="nav-link" text="Candidate" right>
                  <b-dropdown-item class="dropdown-item" to="/login">Login</b-dropdown-item>
                  <b-dropdown-item class="dropdown-item" to="/register?t=candidate">Register</b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>
              <b-navbar-nav class="ml-auto" v-if="user != null && $route.meta.showMenu">
                <b-nav-item class="nav-link" @click="redirectToProfile">Profile</b-nav-item>
                <b-nav-item class="nav-link" @click="logout">Logout</b-nav-item>
              </b-navbar-nav>
            </b-collapse> -->
          </b-navbar>
        </div>
      </b-container>

      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>

      <!-- Footer -->
      <!-- <footer class="footer bg-light mt-5 py-3">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 h-100 text-center text-lg-left my-auto">
              <ul class="list-inline mb-2">
                <li class="list-inline-item">
                  <b-link href="https://www.careerpilot.co/termsofservice" target="_BLANK">Terms of Service</b-link>
                </li>
                <li class="list-inline-item">&sdot;</li>
                <li class="list-inline-item">
                  <b-link href="https://www.careerpilot.co/privacy" target="_BLANK">Privacy Policy</b-link>
                </li>
              </ul>
              <p class="text-muted small mb-lg-0">&copy; Career Pilot {{year}}. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
  </div>
</template>
<script>
import LogRocket from 'logrocket';
import Auth from '@/fstore/auth';
import User from '@/fstore/collections/User';
import Overlay from "./components/Overlay.vue";
import Alert from "./components/Alert.vue";
// import firebase from "@/Firebase";

export default {
  components: {
    Overlay,
    Alert
  },
  data: function() {
    return {
      year: new Date().getFullYear(),
      user: null
    };
  },
  async created () {
    await this.$store.dispatch('auth/getAuth')
    this.user = await User.currentUser();
    LogRocket.init('slucf8/career-pilot');
  },
  methods: {
    async redirectToProfile() {
      let url = await Auth.getRedirectURL();

      if(!url)
        this.router.push({name: 'home'})
      else
        this.$router.push(url);
    },
    async logout() {
      this.$store.dispatch("app/setOverlay", true);
      await Auth.logout();
      this.$store.dispatch("app/setOverlay", false);
      this.user = null;
    },
  }
};
</script>
